// ⚠ 本文件由 scripts/gen-from-schema.js 从 probe/schema.json 生成，请勿手改。
// 重新生成：npm run gen -w @cdfjx/shared
// 源字段数：43

import type { FieldType } from './cell-value';

/** 「投诉信息清单」全部 43 个字段的真实定义（field_id / field_name / field_type）。 */
export const FIELDS = {
  "文本": { id: "2f8fabf9", name: "文本", type: "text" },
  "用户提交时间": { id: "5ce57ba7", name: "用户提交时间", type: "date" },
  "处理状态": { id: "af956e74", name: "处理状态", type: "single_select" },
  "受理判定": { id: "8adc9dde", name: "受理判定", type: "text" },
  "不予受理理由": { id: "ed74161e", name: "不予受理理由", type: "text" },
  "ai受理开始时间": { id: "0c59ac73", name: "ai受理开始时间", type: "date" },
  "ai受理结束时间": { id: "dcd8b854", name: "ai受理结束时间", type: "date" },
  "生成告知书开始时间": { id: "77582142", name: "生成告知书开始时间", type: "date" },
  "生成告知书结束时间": { id: "e911bdb6", name: "生成告知书结束时间", type: "date" },
  "ai判定开始时间": { id: "b54b6982", name: "ai判定开始时间", type: "date" },
  "ai判定结束时间": { id: "060b32a5", name: "ai判定结束时间", type: "date" },
  "办结时间": { id: "8384fdc2", name: "办结时间", type: "date" },
  "乐享临时证据目录ID": { id: "0af49efd", name: "乐享临时证据目录ID", type: "text" },
  "投诉人姓名": { id: "68de61b4", name: "投诉人姓名", type: "text" },
  "投诉人电话": { id: "f8fe5c5d", name: "投诉人电话", type: "text" },
  "投诉人身份": { id: "d9085c70", name: "投诉人身份", type: "text" },
  "被投诉人姓名": { id: "43170763", name: "被投诉人姓名", type: "text" },
  "被投诉人电话": { id: "7c44978d", name: "被投诉人电话", type: "text" },
  "被投诉人星级服务牌": { id: "2aa83ac2", name: "被投诉人星级服务牌", type: "text" },
  "被投诉机构": { id: "7210be8c", name: "被投诉机构", type: "text" },
  "案件领域": { id: "1848d17a", name: "案件领域", type: "text" },
  "房产标的": { id: "3e2eb18b", name: "房产标的", type: "text" },
  "投诉事项": { id: "b5a3b871", name: "投诉事项", type: "text" },
  "诉求": { id: "bb7a41b3", name: "诉求", type: "text" },
  "被投诉人星级状态": { id: "ba14b8f6", name: "被投诉人星级状态", type: "text" },
  "被投诉人会员状态": { id: "da9ded09", name: "被投诉人会员状态", type: "text" },
  "机构备案状态": { id: "1489993a", name: "机构备案状态", type: "text" },
  "机构星级": { id: "d52f1631", name: "机构星级", type: "text" },
  "直营或加盟": { id: "ef3a5baf", name: "直营或加盟", type: "text" },
  "加盟品牌": { id: "4f63ac77", name: "加盟品牌", type: "text" },
  "违规标签": { id: "ed5d585e", name: "违规标签", type: "text" },
  "投诉原始文本": { id: "3f5e5cfe", name: "投诉原始文本", type: "text" },
  "被投诉人编号": { id: "f84e5eec", name: "被投诉人编号", type: "text" },
  "被投诉人诚信状态": { id: "9fcbf438", name: "被投诉人诚信状态", type: "text" },
  "被投诉人诚信分": { id: "2a904afc", name: "被投诉人诚信分", type: "text" },
  "是否黑名单": { id: "8e357bc3", name: "是否黑名单", type: "text" },
  "老系统投诉类型": { id: "997d982c", name: "老系统投诉类型", type: "number" },
  "老系统业务类型": { id: "a455a135", name: "老系统业务类型", type: "number" },
  "区域ID": { id: "3e5d9038", name: "区域ID", type: "number" },
  "老系统投诉ID": { id: "1f096507", name: "老系统投诉ID", type: "text" },
  "推送状态": { id: "a3b0ad8c", name: "推送状态", type: "text" },
  "工单编号": { id: "3e054669", name: "工单编号", type: "text" },
  "案卷ID": { id: "7a328108", name: "案卷ID", type: "text" },
} as const;

/** 43 个字段的中文名联合类型。 */
export type FieldName = keyof typeof FIELDS;

/** 取某字段的 field_type 字面量。 */
export type FieldTypeOf<K extends FieldName> = (typeof FIELDS)[K]['type'];

export interface SelectOptionDef {
  id: string;
  name: string;
  color?: string;
}

/**
 * 运行期字段定义。
 * 注意：smartsheet_list_fields 把选项放在 `single_select.options` 下，
 * 而 probe/schema.json 把它拍平成了 `options`——两种形状都要吃得下，
 * 客户端读到后统一归一到 `options`。
 */
export interface FieldDef {
  field_id: string;
  field_name: string;
  field_type: FieldType | string;
  is_primary?: boolean;
  /** 归一后的选项（客户端填） */
  options?: SelectOptionDef[];
  /** 服务端原始形状 */
  single_select?: { options?: SelectOptionDef[] };
  multi_select?: { options?: SelectOptionDef[] };
}

/** 主键列（列名改不动，存工单编号同值）。 */
export const PRIMARY_FIELD_NAME = "文本" as const;

export const PRIMARY_FIELD_ID = "2f8fabf9" as const;

/** 全部字段名数组，顺序与建表一致。 */
export const FIELD_NAMES = [
  "文本",
  "用户提交时间",
  "处理状态",
  "受理判定",
  "不予受理理由",
  "ai受理开始时间",
  "ai受理结束时间",
  "生成告知书开始时间",
  "生成告知书结束时间",
  "ai判定开始时间",
  "ai判定结束时间",
  "办结时间",
  "乐享临时证据目录ID",
  "投诉人姓名",
  "投诉人电话",
  "投诉人身份",
  "被投诉人姓名",
  "被投诉人电话",
  "被投诉人星级服务牌",
  "被投诉机构",
  "案件领域",
  "房产标的",
  "投诉事项",
  "诉求",
  "被投诉人星级状态",
  "被投诉人会员状态",
  "机构备案状态",
  "机构星级",
  "直营或加盟",
  "加盟品牌",
  "违规标签",
  "投诉原始文本",
  "被投诉人编号",
  "被投诉人诚信状态",
  "被投诉人诚信分",
  "是否黑名单",
  "老系统投诉类型",
  "老系统业务类型",
  "区域ID",
  "老系统投诉ID",
  "推送状态",
  "工单编号",
  "案卷ID",
] as const;

/**
 * 43 个字段名再写死一遍（与 FIELDS 的 key 互为校验）。
 * assertions.ts 里断言二者相等——任何一边被手改都会编译失败。
 */
export type FieldNameLiterals =
  | "文本"
  | "用户提交时间"
  | "处理状态"
  | "受理判定"
  | "不予受理理由"
  | "ai受理开始时间"
  | "ai受理结束时间"
  | "生成告知书开始时间"
  | "生成告知书结束时间"
  | "ai判定开始时间"
  | "ai判定结束时间"
  | "办结时间"
  | "乐享临时证据目录ID"
  | "投诉人姓名"
  | "投诉人电话"
  | "投诉人身份"
  | "被投诉人姓名"
  | "被投诉人电话"
  | "被投诉人星级服务牌"
  | "被投诉机构"
  | "案件领域"
  | "房产标的"
  | "投诉事项"
  | "诉求"
  | "被投诉人星级状态"
  | "被投诉人会员状态"
  | "机构备案状态"
  | "机构星级"
  | "直营或加盟"
  | "加盟品牌"
  | "违规标签"
  | "投诉原始文本"
  | "被投诉人编号"
  | "被投诉人诚信状态"
  | "被投诉人诚信分"
  | "是否黑名单"
  | "老系统投诉类型"
  | "老系统业务类型"
  | "区域ID"
  | "老系统投诉ID"
  | "推送状态"
  | "工单编号"
  | "案卷ID";

export const FIELD_ID_TO_NAME: Readonly<Record<string, FieldName>> = Object.freeze(
  Object.fromEntries(
    (Object.keys(FIELDS) as FieldName[]).map((n) => [FIELDS[n].id, n]),
  ) as Record<string, FieldName>,
);
